<template>
  <div class="mt-4 pcc" :style="comingSoon ? null : { maxWidth: '480px' }">
    <!-- 준비중 채널: 제목 + 안내만 -->
    <template v-if="comingSoon">
      <h5>{{ title }}</h5>
      <span class="text-body-2 grey--text">{{ $t("common.comingSoon") }}</span>
    </template>

    <template v-else>
      <!-- 헤더: 제목(좌) + 상태칩(우). 채널명은 input 안에 표시 -->
      <div class="d-flex align-center justify-space-between mb-1">
        <h5 class="mb-0">{{ title }}</h5>
        <v-chip v-if="connected" color="success" outlined small>
          <v-icon left small>mdi-check-circle</v-icon>{{ $t("broadcastManage.connected") }}
        </v-chip>
        <v-chip v-else color="grey" outlined small>{{ $t("broadcastManage.notConnected") }}</v-chip>
      </div>

      <!-- 설명 -->
      <p class="text-caption grey--text mb-3">{{ desc }}</p>

      <!-- 입력 (입력형 채널만) -->
      <slot name="input"></slot>

      <!-- 추가 액션 버튼 (있을 때만). 연동/해제는 input 안 버튼으로 통합됨 -->
      <div v-if="$slots.actions" class="d-flex align-center">
        <slot name="actions"></slot>
      </div>

      <!-- 방송화면에서 사용 토글 (연동 시에만, showToggle 채널만) — 라벨 좌, 스위치 우 (디자인 시스템 AppSwitch) -->
      <template v-if="showToggle && connected">
        <div class="d-flex align-center justify-end mt-3">
          <AppSwitch :value="enabled" :loading="enabledBusy" label-left @input="$emit('toggle', $event)">
            {{ $t("broadcastManage.useInBroadcast") }}
          </AppSwitch>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
// 방송 채널 카드 — 전 채널 동일 위계로 통일 (제목+상태 / 입력 / 버튼 / 구분선+토글).
// 플랫폼별로 다른 부분(입력 필드, 연동/해제 버튼)은 슬롯으로 주입.
export default {
  name: "PlatformChannelCard",
  props: {
    title: { type: String, default: "" },
    desc: { type: String, default: "" },
    connected: { type: Boolean, default: false },
    showToggle: { type: Boolean, default: false },
    enabled: { type: Boolean, default: false },
    enabledBusy: { type: Boolean, default: false },
    comingSoon: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* 평면 카드: 그림자/테두리 없이 안쪽 패딩만 */
.pcc {
  padding: 16px;
}
/* (활성화 스위치는 AppSwitch로 교체 — 전용 CSS 불필요) */
.pcc-switch >>> .v-input__slot {
  margin-bottom: 0;
}
.pcc-switch >>> .v-input--selection-controls__input {
  margin-right: 0;
}
</style>
